const shadow = {
    mounted(el, binding) {
        let top = binding.value.top;
        let target = binding.value.target || '#page';


        const onScroll = (event) => {
            let elTop = el.getBoundingClientRect().top;
            if (elTop <= top) {
                el.classList.add('shadow-md');
            } else {
                el.classList.remove('shadow-md');
            }
        };

        let targetElement = document.querySelector(target);
        if (!targetElement) {
            return;
        }

        targetElement.addEventListener('scroll', onScroll);
        el._onScroll = onScroll;
    },

    unmounted(el) {
        el.removeEventListener('scroll', el._onScroll);
        delete el._onScroll;
    }
};

const wScroll = {
    async mounted(el, binding) {
        let { scrollEl, at, apply, disabled } = binding.value;

        if (disabled) {
            return;
        }

        const onScroll = (event) => {
            let scrollTop = event.target.scrollTop;
            let elOffsetY = el.getBoundingClientRect().top;

            if (scrollTop >= at) {
                apply.split(' ').forEach((className) => {
                    el.classList.add(className);
                });
            } else {
                apply.split(' ').forEach((className) => {
                    el.classList.remove(className);
                });
            }
        };

        setTimeout(() => {
            let scrollHtmlTarget = document.querySelector(scrollEl);

            // the vue element (scrollEl) might not be rendered yet
            // so i have to wait for it to be rendered
            if (!scrollHtmlTarget) {
                let interval = setInterval(() => {
                    scrollHtmlTarget = document.querySelector(scrollEl);
                    if (scrollHtmlTarget) {
                        clearInterval(interval);
                    }
                }, 100);
            }

            if (scrollHtmlTarget) {
                scrollHtmlTarget.addEventListener('scroll', onScroll);
            }

            el._onScroll = onScroll;
            el._scrollHtmlTarget = scrollHtmlTarget;
        }, 1000);
    },

    unmounted(el, binding) {
        el._scrollHtmlTarget?.removeEventListener('scroll', el._onScroll);
        delete el._onScroll;
    }
};

export { wScroll, shadow };